<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button mode="md"></ion-back-button>
    </ion-buttons>
    <ion-title> Connect card reader </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <salonmonster-load-mask *ngIf="isLoading"></salonmonster-load-mask>
  <salonmonster-tap-retry
    *ngIf="errorOccurredWhileLoadingStats"
    (click)="onTapToReload()"
  ></salonmonster-tap-retry>
  <ng-container *ngIf="!isLoading && !errorOccurredWhileLoadingStats">
    <ion-row>
      <ion-col class="hidden-sm-down"></ion-col>
      <ion-col size="12" size-sm="12" size-md="8" size-lg="8" size-xl="8">
        <ion-col size="12" *ngIf="existingTerminal && !searchingForCardReader">
          <h2 class="ion-text-center payment-title">
            We found the following card reader(s) on your local network
          </h2>
          <ion-row>
            <ion-col
              *ngFor="let reader of readers; let i = index"
              size="8"
              [ngClass]="'connectedTerminalBlock readerP400lBlock'"
            >
              <img
                src="../../../assets/images/bbpos-wisepos-e.png"
                class="cardReaderImage"
                alt=""
              /><br />
              <span class="verifoneSpan">BBPOS</span><br />
              <span class="cardReaderSpan reader-serial-number"
                >(S/N: {{reader.reader.serial_number}})</span
              ><br />
              <ion-button
                *ngIf="!connectPushed[i]  && !reader.status"
                (click)="connectCardReader(reader.reader, i)"
                color="primary"
                ng-reflect-color="primary"
                class="button button-md button-default button-default-md button-md-primary"
              >
                <span class="button-inner">Connect</span>
              </ion-button>
              <ion-button
                *ngIf="reader.status && !disconnectPush[i]"
                (click)="disconnectReader(reader.reader, i)"
                fill="outline"
                ng-reflect-outline=""
                class="button button-md button-default button-outline button-outline-md"
                style="
                  touch-action: pan-y;
                  user-select: none;
                  -webkit-user-drag: none;
                  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                "
              >
                <span class="button-inner">Disconnect</span>
              </ion-button>
              <div
                *ngIf="(connectPushed[i] || disconnectPush[i]) && !cardReaderConnectError[i]"
                class="mini-loading"
              >
                <salonmonster-small-checkmark-loader
                  [completed]="readerConnectSuccessful[i] || readerDisconnectSuccessful[i]"
                ></salonmonster-small-checkmark-loader>

                <span *ngIf="cardReaderConnectError[i]">
                  <p
                    class="sm-error ion-text-center display-inline margin-left-10"
                  >
                    Oops! something went wrong
                  </p>
                </span>
              </div>
            </ion-col>
          </ion-row>
          <ion-button
            (click)="discoverReaders(false)"
            fill="outline"
            ng-reflect-outline=""
            class="margin-top-50 button button-md button-outline button-outline-md center-block payment-process-button"
            style="
              touch-action: pan-y;
              user-select: none;
              -webkit-user-drag: none;
              -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
            "
          >
            <span class="button-inner">Search again</span>
          </ion-button>
        </ion-col>
        <ion-col size="12" *ngIf="searchingForCardReader">
          <h2 class="ion-text-center payment-title">
            Searching for card readers on your local network
          </h2>
          <p class="ion-text-center">
            Please make sure your card reader is plugged in, powered on, and
            connected to your local network.
          </p>
          <ion-row size="12" class="height-200">
            <salonmonster-load-mask
              [ngClass]="'center-block'"
              *ngIf="searchingForCardReader"
            ></salonmonster-load-mask>
          </ion-row>
        </ion-col>
        <ion-col size="12" *ngIf="!existingTerminal && !searchingForCardReader">
          <h2 class="ion-text-center payment-title">
            We couldn't find any card readers on your local network
          </h2>
          <p class="ion-text-center">
            Please make sure your card reader is plugged in, powered on, and
            connected to your local network.
          </p>

          <ion-button
            (click)="discoverReaders(false)"
            fill="outline="
            ng-reflect-outline=""
            class="button button-md button-outline button-outline-md center-block payment-process-button"
            style="
              touch-action: pan-y;
              user-select: none;
              -webkit-user-drag: none;
              -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
            "
          >
            <span class="button-inner">Search again</span>
          </ion-button>
        </ion-col>
        <ion-col size="12">
          <h2 class="ion-text-center payment-title">
            Got new hardware to connect?
          </h2>
          <ion-button
            (click)="onRegisterCardReader()"
            ng-reflect-color=""
            [ngClass]="(existingTerminal && !searchingForCardReader) ? 'button-outline button-outline-md':'button-default button-default-md button-md-primary'"
            class="button button-md center-block payment-process-button"
          >
            <span class="button-inner">Register a new card reader</span>
          </ion-button>
        </ion-col>
      </ion-col>
      <ion-col class="hidden-sm-down"></ion-col>
    </ion-row>
  </ng-container>
</ion-content>
